import { TOKEN_LOCAL_STORAGE } from '@api/data/authentication.service'
import { type Socket, io } from 'socket.io-client'
import { getSocketIoConfig } from '../utils'

class SocketService {
  private socket: Socket | null = null

  init(user) {
    if (this.socket) {
      return
    }

    const token = localStorage.getItem(TOKEN_LOCAL_STORAGE)

    const { baseUrl, path } = getSocketIoConfig()

    this.socket = io(baseUrl, {
      path,
      transports: ['websocket'],
      autoConnect: true,
      reconnection: true,
      auth: {
        companyId: user.companyId,
        userId: user.id,
        token,
      },
    })

    this.socket.on('connect', () => {
      console.info('Socket connected')
    })

    this.socket.on('disconnect', () => {
      console.info('Socket disconnected')
    })

    this.socket.on('reconnect_failed', () => {
      console.info('Socket failed to reconnect after maximum attempts')
    })
  }

  getSocket(user) {
    if (!this.socket) this.init(user)
    else if (this.socket.disconnected) {
      this.socket.connect()
    }
    return this.socket
  }
}

export const socketService = new SocketService()
